<template>
  <page-frame headStyle="height: 4.78rem;" bodyStyle="top: 4.78rem;">
    <div class="header-menu" slot="head">
      <header-bar slot="head" navStyle="padding-left:.266rem;padding-right:.266rem;">
        <span slot="left">{{ $t("mall_modules_editrole_fanhui") }}</span>
        <span>{{ $t(objSave.centerTitle) }}</span>
      </header-bar>
      <div>
        <div style="margin:0.266rem;overflow: hidden;">
          <input type="text" v-model="search" :placeholder="$t('placeholders.searchTraveller')" style="padding-left:0.266rem;border:0;height: 0.930rem;width: 100%;" />
        </div>
        <div class="PassengerInfos-addBtn">
          <div @click="editTraveller('')">
            <i class="fa fa-plus"></i>
            <span>{{ $t("mall.addTraveller") }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="page-content">
      <Scroll
        ref="scroll"
        :data="model.passengerInfos"
        :scrollbar="scrollbarObj"
        :pullUpLoad="pullUpLoadObj"
        :startY="parseInt(startY)"
        @pullingUp="onPullingUp"
        :pullDownRefresh="pullDownRefreshObj"
        @pullingDown="onPullingDown"
      >
        <ul class="content">
          <li>
            <div
              @click="addTraveller($event, passengerInfo.RoleID, passengerInfo.Cards)"
              :for="passengerInfo.RoleID"
              v-for="(passengerInfo, index) in model.passengerInfos"
              class="selectTraveller-wrapper"
              :key="passengerInfo.RoleID"
            >
              <div class="selectTraveller-item">
                <div>{{ passengerInfo.RoleName }}</div>
                <img src="/static/img/left1.png" />
              </div>
              <div class="border_bottom" v-if="index != model.passengerInfos.length - 1"></div>
            </div>
          </li>
        </ul>
      </Scroll>
    </div>
  </page-frame>
</template>
<script>
  import Scroll from "../modules/Scroll.vue";
  import PassengerInfos from "./modules/PassengerInfos.vue";
  import navBar from "../modules/navBar.vue";
  import UserService from "@/service/UserService";
  import { CardType } from "@/model/Base";
  export default {
    data() {
      return {
        search: "",
        searchPageNo: 1,
        PageNo: 1,
        PageSize: 15,
        totalNums: "",
        scrollbar: false,
        scrollbarFade: true,
        pullDownRefresh: true,
        pullDownRefreshThreshold: 90,
        pullDownRefreshStop: 40,
        pullUpLoad: true,
        pullUpLoadThreshold: 0,
        pullUpLoadMoreTxt: "share.pullUpLoadMoreTxt",
        pullUpLoadNoMoreTxt: "share.pullUpLoadNoMoreTxt",
        startY: 0,
        scrollToX: 0,
        scrollToY: -200,
        scrollToTime: 700,
        scrollToEasing: "bounce",
        scrollToEasingOptions: ["bounce", "swipe", "swipeBounce"],
        model: {
          selectTraveller: [],
          passengerInfos: [],
        },
        objSave: {
          centerTitle: "mall.frequentlnformationTitle",
          rightTitle: {
            isShow: true,
            type: "button",
            label: "share.confirmTxt",
            fnName: "fnSave",
          },
        },
        AllDatas: [],
        minPageCurrent: null,
        maxPageCurrent: null,
        CloneAllDatas: [],
        PassengerTypes: [
          {
            label: this.$root.$t("system_mall_oftenpassenger_gongsichangke"),
            value: "Company",
            Code: "Company",
          },
          {
            label: this.$root.$t("system_mall_oftenpassenger_gerenchangke"),
            value: "People",
            Code: "People",
          },
        ],
        PassengerType: "Company",
      };
    },
    computed: {
      // CardTypeTypes() {
      //   return this.$store.getters.categorys.types.CardType;
      // },
      // CardTypes() {
      //   return this.$route.query.CardTypes;
      // },
      ApplyArea() {
        return this.$route.query.ApplyArea;
      },
      BookingType() {
        return this.$route.query.BookingType;
      },
      scrollbarObj: function() {
        return this.scrollbar
          ? {
              fade: this.scrollbarFade,
            }
          : false;
      },
      pullUpLoadObj: function() {
        return this.pullUpLoad
          ? {
              threshold: parseInt(this.pullUpLoadThreshold),
              txt: {
                more: this.pullUpLoadMoreTxt,
                noMore: this.pullUpLoadNoMoreTxt,
              },
            }
          : false;
      },
      pullDownRefreshObj: function() {
        return this.pullDownRefresh
          ? {
              threshold: parseInt(this.pullDownRefreshThreshold),
              stop: parseInt(this.pullDownRefreshStop),
            }
          : false;
      },
    },
    watch: {
      scrollbarObj: {
        handler() {
          this.rebuildScroll();
        },
        deep: true,
      },
      pullDownRefreshObj: {
        handler() {
          this.rebuildScroll();
        },
        deep: true,
      },
      pullUpLoadObj: {
        handler() {
          this.rebuildScroll();
        },
        deep: true,
      },
      startY() {
        this.rebuildScroll();
      },
      search(newVal) {
        let __self = this;
        __self.CloneAllDatas = __self.AllDatas;
        if (newVal == "" || newVal == null) {
          __self.model.passengerInfos = [];
          __self.PageNo = 1;
          let filterDatas = __self.loadDatas(__self.CloneAllDatas);
          __self.model.passengerInfos = filterDatas;
          __self.pullUpLoad = true;
          __self.pullDownRefresh = true;
          __self.rebuildScroll();
        } else {
          __self.model.passengerInfos = [];
          let datas = [];
          __self.CloneAllDatas.forEach(element => {
            if (element.RoleName.indexOf(newVal) >= 0) {
              datas.push(element);
            }
          });
          let minPageCurrent = __self.PageSize * (__self.searchPageNo - 1);
          let maxPageCurrent = __self.PageSize * __self.searchPageNo;
          if (maxPageCurrent >= datas.length) {
            maxPageCurrent = datas.length;
          }
          for (let i = minPageCurrent; i < maxPageCurrent; i++) {
            __self.model.passengerInfos.push(datas[i]);
          }
          if (__self.model.passengerInfos.length < 15) {
            __self.rebuildScroll();
            __self.pullUpLoad = false;
            __self.pullDownRefresh = false;
          } else {
            __self.pullUpLoad = true;
            __self.pullDownRefresh = true;
          }
          __self.CloneAllDatas = datas;
        }
      },
    },
    mounted() {
      let __self = this;
      __self.objSave.rightTitle = {};
      __self.minPageCurrent = null;
      __self.maxPageCurrent = null;
      __self.searchPageNo = 1;
      __self.PageNo = 1;
      __self.PageSize = 15;
      __self.__init();
    },
    activated() {
      let __self = this;
      // if (Object.keys($utils.Storage).length == 0) {
      //   __self.model.selectTraveller = [];
      // }
    },
    // deactivated() {
    //   $utils.Loading.close();
    // },
    // destroyed() {
    //   $utils.Loading.close();
    // },
    methods: {
      __init() {
        let __self = this;
        if (__self.model.passengerInfos.length <= 0) {
          this.$root.$toast.loading({ duration: 0 });
        }
        UserService.getConsumers().then(json => {
          this.$root.$toast.clear();
          if (json.isSucc) {
            __self.AllDatas = json.result;
            __self.CloneAllDatas = _.cloneDeep(json.result);
            let filterDatas = __self.loadDatas(__self.CloneAllDatas);
            __self.model.passengerInfos = filterDatas;
          }
        });
      },
      Save() {
        let __self = this;
        let passengerInfo = [];
        let Consumers = [];
        let ConsumerName = "";
        for (let i = 0; i < __self.AllDatas.length; i++) {
          let AllData = __self.AllDatas[i];
          for (let j = 0; j < __self.model.selectTraveller.length; j++) {
            if (__self.model.selectTraveller[j] == AllData.RoleID) {
              if (__self.ApplyArea == 1126) {
                ConsumerName = AllData.RoleName;
              }
              if (__self.ApplyArea == 1127) {
                for (let i = 0; i < AllData.Cards.length; i++) {
                  let Cards = AllData.Cards[i];

                  if (Cards.EnglishFirstName == "" || Cards.EnglishFirstName == null) {
                    return $utils.fail(__self.$t("share.fail.EnglishName"), "fail");
                  }
                  if (Cards.EnglishLastName == "" || Cards.EnglishLastName == null) {
                    return $utils.fail(__self.$t("share.fail.EnglishName"), "fail");
                  }
                  ConsumerName = Cards.EnglishFirstName + "/" + Cards.EnglishLastName;
                }
              }
              // passengerInfo.push(AllData);
              Consumers.push({
                ConsumerID: AllData.RoleID,
                ConsumerName: ConsumerName,
                SuperiorName: AllData.SuperiorName,
                SuperiorType: AllData.SuperiorType,
              });
            }
          }
        }
        let AllConsumers = [];
        $utils.Storage.Consumers = JSON.stringify(Consumers);
        if ($utils.Storage.TemporaryInfos != undefined) {
          let TemporaryInfos = JSON.parse($utils.Storage.TemporaryInfos);
          for (let i = 0; i < TemporaryInfos.length; i++) {
            AllConsumers.push(TemporaryInfos[i]);
          }
          for (let i = 0; i < Consumers.length; i++) {
            AllConsumers.push(Consumers[i]);
          }
          $utils.Storage.AllConsumers = JSON.stringify(AllConsumers);
        } else {
          $utils.Storage.AllConsumers = $utils.Storage.Consumers;
        }
        window.sessionStorage.setItem("SelectPassenger", true);
        history.back();
      },
      onPullingUp() {
        let __self = this;
        __self.PageNo++;
        let filterDatas = __self.loadDatas(__self.CloneAllDatas);
        setTimeout(() => {
          if (__self.PageNo <= __self.totalNums) {
            __self.model.passengerInfos = __self.model.passengerInfos.concat(filterDatas);
            if (filterDatas.length > 0) {
              __self.$refs.scroll.forceUpdate(true);
            } else {
              __self.$refs.scroll.forceUpdate();
            }
          }
          __self.$refs.scroll.forceUpdate();
        }, 200);
      },
      onPullingDown() {
        let __self = this;
        __self.minPageCurrent = null;
        __self.maxPageCurrent = null;
        __self.searchPageNo = 1;
        __self.PageNo = 1;
        __self.PageSize = 15;
        __self.__init();
      },
      rebuildScroll() {
        this.$nextTick(() => {
          if (this.$refs.scroll) {
            this.$refs.scroll.destroy();
            this.$refs.scroll.initScroll();
          }
        });
      },
      loadDatas(datas) {
        let __self = this;
        let filterDatas = [];
        __self.minPageCurrent = __self.PageSize * (__self.PageNo - 1);
        __self.maxPageCurrent = __self.PageSize * __self.PageNo;
        __self.totalNums = Math.ceil(datas.length / __self.PageSize);
        if (__self.maxPageCurrent >= datas.length) {
          __self.maxPageCurrent = datas.length;
        }
        for (let i = __self.minPageCurrent; i < __self.maxPageCurrent; i++) {
          filterDatas.push(datas[i]);
        }
        return filterDatas;
      },
      editTraveller(e) {
        let __self = this;
        let query = {
          BookingType: __self.BookingType,
          CardType: CardType.IDCard,
        };
        __self.$router.push({
          path: "/system/addTraveller",
          query: query,
        });
      },
      addTraveller(e, RoleID, Cards) {
        let __self = this;
        let query = {
          BookingType: __self.BookingType,
          CardType: CardType.IDCard,
        };
        if (RoleID == undefined) {
          query.RoleID = undefined;
        } else {
          query.RoleID = RoleID;
          query.ApplyArea = __self.ApplyArea;
        }
        __self.$router.push({
          path: "/system/addTraveller",
          query: query,
        });
      },
    },
    components: {
      PassengerInfos,
      navBar,
      Scroll,
    },
  };
</script>
<style scoped>
  .header-menu header {
    background-color: #12a3ff;
  }

  .header-menu {
    height: 4.149rem;
  }

  .PassengerType {
    padding: 0 0.266rem;
    height: 1.064rem;
    line-height: 1.064rem;
    display: flex;
    justify-content: space-between;
    margin: 0.266rem 0;
  }

  .PassengerType .Active {
    background: #fff;
  }

  .PassengerType > span {
    flex: 2;
    text-align: center;
  }

  .PassengerInfos-addBtn {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 0.93rem;
    padding: 0 0.266rem 0.266rem 0.266rem;
  }

  .PassengerInfos-addBtn > div:first-child {
    border: 0.01rem solid #12a3ff;
    border-radius: 0.106rem;
    padding: 0.133rem 0;
    width: 100%;
    text-align: center;
  }

  .PassengerInfos-addBtn > div:first-child i {
    font-size: 0.478rem;
    color: #12a3ff;
    vertical-align: middle;
  }

  .PassengerInfos-addBtn > div:first-child span {
    color: #12a3ff;
    vertical-align: middle;
  }

  .selectTraveller-wrapper {
    height: 1.596rem;
    padding: 0 0.266rem;
    background-color: #fff;
    display: block;
  }

  .selectTraveller-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 1.596rem;
  }

  .selectTraveller-item img {
    width: 0.372rem;
  }
</style>
